export const smartDocStaticParamType_Finding = 'finding';
//# sourceMappingURL=types.js.map